import "./NotFoundPage.styl";

import React from "react";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import { Link } from "react-router";
import { Container, Row, Col } from "reactstrap";
import { connect } from "react-redux";

let NotFoundPage = ({ intl, appPath }) => (
  <div className="not-found-page">
    <Container>
      <div className="main-content container-fluid">
        <div className="error-container">
          <div className="error-number">404</div>
          <div className="error-description">
            Strona, którą próbujesz załadować nie istnieje.
          </div>
          <div className="error-goback-text">
            Chcesz wrócić do strony głównej? ;)
          </div>
          <div className="error-goback-button">
            <Link to={appPath} className="btn btn-xl btn-primary">
              Wróć do domu
            </Link>
          </div>
        </div>
      </div>
    </Container>
  </div>
);

NotFoundPage.propTypes = {
  intl: intlShape.isRequired
};

NotFoundPage = injectIntl(NotFoundPage);

NotFoundPage = connect(
  state => ({
    appPath: state.config.appPath
  }),
  {}
)(NotFoundPage);

export default NotFoundPage;



/** WEBPACK FOOTER **
 ** ./src/browser/notfound/NotFoundPage.js
 **/